/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_LInputs */

const en_val_l = /** @type {(inputs: Val_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L`)
};

const es_val_l = /** @type {(inputs: Val_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L`)
};

const fr_val_l = /** @type {(inputs: Val_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L`)
};

const de_val_l = /** @type {(inputs: Val_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L`)
};

const ja_val_l = /** @type {(inputs: Val_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L`)
};

const zh_val_l = /** @type {(inputs: Val_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L`)
};

const ar_val_l = /** @type {(inputs: Val_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كبير (L)`)
};

const id_val_l = /** @type {(inputs: Val_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L`)
};

const it_val_l = /** @type {(inputs: Val_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L`)
};

const ru_val_l = /** @type {(inputs: Val_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L`)
};

const pt_val_l = /** @type {(inputs: Val_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G`)
};

const ko_val_l = /** @type {(inputs: Val_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L`)
};

/**
* | output |
* | --- |
* | "L" |
*
* @param {Val_LInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_l = /** @type {((inputs?: Val_LInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_LInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_l(inputs)
	if (locale === "es") return es_val_l(inputs)
	if (locale === "fr") return fr_val_l(inputs)
	if (locale === "de") return de_val_l(inputs)
	if (locale === "ja") return ja_val_l(inputs)
	if (locale === "zh") return zh_val_l(inputs)
	if (locale === "ar") return ar_val_l(inputs)
	if (locale === "id") return id_val_l(inputs)
	if (locale === "it") return it_val_l(inputs)
	if (locale === "ru") return ru_val_l(inputs)
	if (locale === "pt") return pt_val_l(inputs)
	return ko_val_l(inputs)
});